import React from "react";
import { Pause } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/api";

function fmtDuration(secs) {
  if (!secs || secs <= 0) return "0m";
  const h = Math.floor(secs / 3600);
  const m = Math.floor((secs % 3600) / 60);
  if (h && m) return `${h}h ${m}m`;
  if (h) return `${h}h`;
  return `${m}m`;
}

function Stat({ label, value, testid }) {
  return (
    <div data-testid={testid}>
      <div className="overline text-[10px]">{label}</div>
      <div className="font-mono-data text-lg mt-0.5 tabular-nums">{value}</div>
    </div>
  );
}

export function JobTimeTrackingCard({ job }) {
  if (!job.time_tracking || !job.time_tracking.started_at) return null;
  return (
    <div className="rmms-card p-5" data-testid="job-time-tracking">
      <div className="flex items-center justify-between mb-3">
        <div className="overline">Time tracking</div>
        {job.time_tracking.is_paused && (
          <span className="inline-flex items-center gap-1 text-[11px] font-heading uppercase tracking-wider font-semibold px-2 py-0.5 rounded-sm bg-amber-50 text-amber-700 border border-amber-300">
            <Pause size={10} weight="fill" /> currently paused
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 text-sm">
        <Stat label="Active" value={fmtDuration(job.time_tracking.active_seconds)} testid="tt-active" />
        <Stat label="Paused" value={fmtDuration(job.time_tracking.paused_seconds)} testid="tt-paused" />
        <Stat label="Total elapsed" value={fmtDuration(job.time_tracking.total_seconds)} testid="tt-total" />
      </div>
      {(job.pause_log || []).length > 0 && (
        <div className="mt-4 pt-3 border-t border-slate-100">
          <div className="overline mb-2">Pause history</div>
          <ul className="space-y-1.5 text-[12px]" data-testid="job-pause-log">
            {(job.pause_log || []).map((p, i) => (
              <li key={p.paused_at || `pause-${i}`} className="flex items-start gap-2">
                <span className="font-mono-data text-slate-500 mt-0.5">{i + 1}.</span>
                <div className="flex-1">
                  <div className="font-medium">{p.reason}</div>
                  <div className="text-slate-500 font-mono-data text-[10px]">
                    {fmtDate(p.paused_at)}{p.resumed_at ? ` → ${fmtDate(p.resumed_at)}` : " (ongoing)"}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
